import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-website-layout',
  templateUrl: './website-layout.component.html',
  styleUrls: ['./website-layout.component.scss']
})
export class WebsiteLayoutComponent implements OnInit {

  menuVariable:boolean=false
  menu_icon_variable:boolean=false


  constructor() { }

  ngOnInit(): void {
  }

  openMenu(){
    this.menuVariable =! this.menuVariable;
    // this.menu_icon_variable =! this.menu_icon_variable;
    
  }

}
